export default "__VITE_ASSET__b443b361__"